import * as React from 'react';
import {Query, Mutation} from 'react-apollo';
import {withRouter} from 'react-router-dom';
// @ts-expect-error
import type {ContextRouter} from 'react-router-dom';

import type {
    ConditionInput,
    GetClosedLeadSlackMessage as GetClosedLeadSlackMessageQuery,
    GetClosedLeadSlackMessageVariables as GetClosedLeadSlackMessageQueryVariables,
    CreateClosedLeadSlackMessage as CreateClosedLeadSlackMessageMutation,
    CreateClosedLeadSlackMessageVariables as CreateClosedLeadSlackMessageMutationVariables,
    UpdateClosedLeadSlackMessage as UpdateClosedLeadSlackMessageMutation,
    UpdateClosedLeadSlackMessageVariables as UpdateClosedLeadSlackMessageMutationVariables,
    DeleteClosedLeadSlackMessage as DeleteClosedLeadSlackMessageMutation,
    DeleteClosedLeadSlackMessageVariables as DeleteClosedLeadSlackMessageMutationVariables,
} from 'nutshell-graphql-types';

import {refetchSalesAutomationOpenLeadQueries} from '../../app/sales-automation-open-leads';
import CREATE_CLOSED_LEAD_SLACK_MESSAGE from '../../graphql/mutations/create-closed-lead-slack-message.graphql';
import DELETE_CLOSED_LEAD_SLACK_MESSAGE from '../../graphql/mutations/delete-closed-lead-slack-message.graphql';
import UPDATE_CLOSED_LEAD_SLACK_MESSAGE from '../../graphql/mutations/update-closed-lead-slack-message.graphql';
import GET_CLOSED_LEAD_SLACK_MESSAGE from '../../graphql/queries/get-closed-lead-slack-message.graphql';

import {FormSlackGraphQLComponent} from './form-slack-graphql-component';

class SlackMessageQuery extends Query<
    GetClosedLeadSlackMessageQuery,
    GetClosedLeadSlackMessageQueryVariables
> {}

class CreateMutation extends Mutation<
    CreateClosedLeadSlackMessageMutation,
    CreateClosedLeadSlackMessageMutationVariables
> {}

class UpdateMutation extends Mutation<
    UpdateClosedLeadSlackMessageMutation,
    UpdateClosedLeadSlackMessageMutationVariables
> {}

class DeleteMutation extends Mutation<
    DeleteClosedLeadSlackMessageMutation,
    DeleteClosedLeadSlackMessageMutationVariables
> {}

type OwnProps = {
    formSubmitBtnRef: (arg1?: HTMLInputElement | null | undefined) => void;
    parentId: string;
    entityId: string | null | undefined;
};

type RoutedProps = ContextRouter & OwnProps;

export const FormClosedLeadSlackGraphQL = (props: RoutedProps) => {
    const {stagesetId} = props.match.params;
    if (!stagesetId) return null;

    return (
        <SlackMessageQuery
            query={GET_CLOSED_LEAD_SLACK_MESSAGE}
            skip={!props.entityId}
            variables={{
                id: props.entityId || '' /* Needed to keep flow happy, won't happen because skip */,
            }}
            // @ts-expect-error
            fetchPolicy='cache-and-network'
        >
            {({data, loading}) => {
                const closedLeadSlackMessage = data ? data.closedLeadSlackMessage : null;

                return (
                    <CreateMutation
                        mutation={CREATE_CLOSED_LEAD_SLACK_MESSAGE}
                        // @ts-expect-error
                        refetchQueries={refetchSalesAutomationOpenLeadQueries({
                            stageId: props.parentId,
                        })}
                    >
                        {(createSlackAutomation) => (
                            <UpdateMutation
                                mutation={UPDATE_CLOSED_LEAD_SLACK_MESSAGE}
                                // @ts-expect-error
                                refetchQueries={refetchSalesAutomationOpenLeadQueries({
                                    stageId: props.parentId,
                                })}
                            >
                                {(updateSlackAutomation) => (
                                    <DeleteMutation
                                        mutation={DELETE_CLOSED_LEAD_SLACK_MESSAGE}
                                        // @ts-expect-error
                                        refetchQueries={refetchSalesAutomationOpenLeadQueries({
                                            stageId: props.parentId,
                                        })}
                                    >
                                        {(deleteSlackAutomation) => (
                                            <FormSlackGraphQLComponent
                                                stagesetId={stagesetId}
                                                // @ts-expect-error
                                                entityId={props.entityId}
                                                parentId={props.parentId}
                                                isFetchingLatestVersion={loading}
                                                slackMessageAutomation={closedLeadSlackMessage}
                                                formSubmitBtnRef={props.formSubmitBtnRef}
                                                onSubmit={(
                                                    channelId: string,
                                                    conditions: ConditionInput[],
                                                    outcomeType: string
                                                ) => {
                                                    const saveStepTemplatePromise =
                                                        closedLeadSlackMessage
                                                            ? updateSlackAutomation({
                                                                  variables: {
                                                                      closedLeadSlackMessage: {
                                                                          id: closedLeadSlackMessage.id,
                                                                          conditions: conditions,
                                                                          channelId: channelId,
                                                                      },
                                                                  },
                                                              })
                                                            : createSlackAutomation({
                                                                  variables: {
                                                                      closedLeadSlackMessage: {
                                                                          stagesetId: stagesetId,
                                                                          conditions: conditions,
                                                                          channelId: channelId,
                                                                          // Dumb cast to any because we don't validate outcomeType string
                                                                          outcomeType:
                                                                              outcomeType as any,
                                                                      },
                                                                  },
                                                              });

                                                    return saveStepTemplatePromise;
                                                }}
                                                deleteSlackAutomation={(slackAutomationId) =>
                                                    deleteSlackAutomation({
                                                        variables: {
                                                            closedLeadSlackMessage: {
                                                                id: slackAutomationId,
                                                            },
                                                        },
                                                    })
                                                }
                                            />
                                        )}
                                    </DeleteMutation>
                                )}
                            </UpdateMutation>
                        )}
                    </CreateMutation>
                );
            }}
        </SlackMessageQuery>
    );
};

// @ts-expect-error
export const FormClosedLeadSlack = withRouter<OwnProps>(FormClosedLeadSlackGraphQL);
